export default __webpack_public_path__ + "static/media/logo.e67845da.png";